import { css } from 'styled-components';

export const fontStyle = fs => css`
  font-style: ${() => fs || 'normal'};
`;
